// 替换多条数据
// 修改数量或SKU可能造成多种结果，包括并不限于以下几种情况：
// 1.混批变为不混批；2.不混批变为混批；3.与其他产品sku相同，造成合并。等等...
// 故此方法大致思路为：
// 1.以cartId为维度，找出源数据中'修改的产品'和'接口返回的产品'
// 2.替换这些产品的标记信息（isChecked，isDisabled）到接口返回的数据中
// 3.在源数据中删除这些数据，再将接口返回的数据添加到源数据
export let replaceSkuData = (originalData, newData, supplierId, itemcode) => {
    let currentListIndex = [];
    let newCartMixList_d = [];
    let newCurrentMixList = [];

    originalData.forEach((store) => {
        // 找到对应店铺
        if (store.supplier.supplierId === supplierId) {
            newData.forEach((newStore)=>{
                if(newStore.supplier.supplierId === supplierId){
                    newCurrentMixList = newStore.cartMixList;
                }

                store.cartMixList.forEach((list, listIndex) => {
                    // 对应店铺下 itemcode相同的产品
                    if (list.itemcode === itemcode) {
                        //获取下标存起来
                        currentListIndex.push(listIndex)
                    }

                    newStore.cartMixList.forEach((newList)=>{
                        list.cartList.forEach((proList, proIndex) => {
                            newList.cartList.forEach((newProList) => {
                                if (proList.product.cartId === newProList.product.cartId) {
                                    // 替换标记信息
                                    newProList.isChecked = proList.isChecked
                                    newProList.isDisabled = proList.isDisabled

                                    //如果返回的数据中，包含同一店铺下不同itemcode的产品，那么直接替换原数据中的该产品
                                    if(newProList.product.productBase.itemcode !== itemcode){
                                        //替换
                                        list.cartList.splice(proIndex, 1, newProList);
                                    }
                                }
                            })
                        })       
                    })
                    
                })
            })

            //当前店铺下 过滤出与当前操作产品的itemcode不同的产品保留
            store.cartMixList.forEach((list, listIndex) => {
                if (!currentListIndex.includes(listIndex)) {
                    newCartMixList_d.push(list)
                }
            })
            store.cartMixList = newCartMixList_d

            // 将接口返回的与当前itemcdoe相同的产品添加到列表里
            for (let i = newCurrentMixList.length - 1; i >= 0; i--) {
                if(newCurrentMixList[i].itemcode === itemcode){
                    store.cartMixList.splice(currentListIndex[0], 0, newCurrentMixList[i]);
                }
            }
        }else{
            //有其他店铺信息返回的情况
            newData.forEach((newStore)=>{
                store.cartMixList.forEach((list)=>{
                    newStore.cartMixList.forEach((newList)=>{
                        list.cartList.forEach((proList, proIndex) => {
                            newList.cartList.forEach((newProList) => {
                                if (proList.product.cartId === newProList.product.cartId) {
                                    // 替换标记信息
                                    newProList.isChecked = proList.isChecked
                                    newProList.isDisabled = proList.isDisabled

                                    //替换
                                    list.cartList.splice(proIndex, 1, newProList);
                                }
                            })
                        })       
                    })
                })
            })
        }
    })

    return originalData;
}